<template>
  <section
    class="new-collection"
    v-if="getCurrentRelatedProducts.length"
  >
    <header class="container">
      <h2>
        {{ heading }}
      </h2>
    </header>
    <product-listing columns="4" :products="getCurrentRelatedProducts" />
  </section>
</template>

<script>
import Related from './Related.vue'
import { prepareRelatedQuery } from '@vue-storefront/core/modules/catalog/queries/related'

function rememberProduct (product, ids, skus) {
  if (!product) return
  if (product.id != null && product.id !== '') ids.add(String(product.id))
  if (product.sku) skus.add(String(product.sku))
  if (product.parentSku) skus.add(String(product.parentSku))
  const children = product.configurable_children
  if (!Array.isArray(children)) return
  children.forEach(child => rememberProduct(child, ids, skus))
}

function isCurrentArticle (item, current, parent) {
  const ids = new Set()
  const skus = new Set()
  rememberProduct(current, ids, skus)
  rememberProduct(parent, ids, skus)
  if (!item) return false
  if (item.id != null && ids.has(String(item.id))) return true
  if (item.sku && skus.has(String(item.sku))) return true
  if (item.parentSku && skus.has(String(item.parentSku))) return true
  return false
}

export default {
  mixins: [Related],
  methods: {
    async refreshList () {
      const current = this.getCurrentProduct
      const requestSku = current && current.sku
      const categoryId = current && current[this.type]
      this.$store.dispatch('product/related', { key: this.type, items: [] })
      if (!categoryId) return false

      const relatedProductsQuery = prepareRelatedQuery('category_ids', categoryId)

      const { items } = await this.$store.dispatch('product/findProducts', {
        query: relatedProductsQuery,
        size: 1000,
        sort: JSON.stringify([
          {
            'category.position': {
              mode: 'avg',
              order: 'asc',
              nested_path: 'category',
              nested_filter: {
                term: { 'category.category_id': categoryId }
              }
            }
          }
        ]),
        options: {
          populateRequestCacheTags: false,
          prefetchGroupProducts: false
        }
      })

      if (!this.getCurrentProduct || this.getCurrentProduct.sku !== requestSku) return
      const accessories = (items || []).filter(item => !isCurrentArticle(item, this.getCurrentProduct, this.getParentProduct))
      this.$store.dispatch('product/related', {
        key: this.type,
        items: accessories
      })
      this.$forceUpdate()
    }
  }
}
</script>
